/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCustomerRequest = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M7 13a6 6 0 0 1 5.996 5.775L13 19v4h-2v-4a4 4 0 0 0-7.995-.2L3 19v4H1v-4a6 6 0 0 1 6-6zM7 3a4 4 0 1 1 0 8 4 4 0 0 1 0-8zm16-2v8h-4.586l-2 2H13V1zM7 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm14-2h-6v6h.584l2.002-2H21z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCustomerRequest as CustomerRequest };
